import React from 'react';
import { Button, Container, Divider, Header } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { Contexto } from 'src/contexto';
import ModalError from '../comun/ModalError';
import { Filtro, MatriculaState, ResumenMatricula } from '../comun/tipos';
import { puedePoseerMatriculas } from '../puedePoseerMatriculas';
import TablaDeProcesos from './TablaDeProcesos';
import BuscadorBasico from './TablaDeProcesos/BuscadorBasico';

type Props = Readonly<{
    ocultar: boolean;
}>;

type State = Readonly<{
    listadoDeMatriculas: Array<ResumenMatricula>;
    numeroDePaginas: number;
    paginaActual: number;
    filtroActual: Filtro;
    cargando: boolean;
    matriculaState?: MatriculaState;
    error?: {
        readonly mensaje: string;
        readonly detalles: Array<string>;
    };
}>;

const stateInicial: State = {
    listadoDeMatriculas: [],
    numeroDePaginas: 0,
    paginaActual: 1,
    filtroActual: 'todas',
    cargando: true,
};

const ITEMS_POR_PAGINA = 50;

class ListaDeProcesos extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = stateInicial;

    public componentDidMount() {
        this.obtenerListaDeMatriculas('todas');
    }

    public componentDidUpdate(prevProps: Props) {
        if (!this.props.ocultar && prevProps.ocultar) {
            this.obtenerListaDeMatriculas(this.state.filtroActual);
        }
    }

    public render() {
        if (this.props.ocultar) return null;

        const {
            filtroActual,
            error,
            numeroDePaginas,
            paginaActual,
            listadoDeMatriculas,
            cargando,
        } = this.state;

        if (error) {
            return (
                <ModalError
                    mensaje={error.mensaje}
                    detalles={error.detalles}
                    alCerrar={() => this.setState({ error: undefined })}
                />
            );
        }

        const limInf = (paginaActual - 1) * ITEMS_POR_PAGINA;
        const limSup = Math.min(paginaActual * ITEMS_POR_PAGINA, listadoDeMatriculas.length);

        return (
            <Container>
                <Header as='h1'>Procesos de matrícula</Header>

                <p>
                    Aquí un <strong>proceso de matrícula</strong> representa todo el conjunto de
                    matrículas y pagaré que tienen un solo apoderado, no cada matrícula (contrato)
                    individual.
                </p>

                <BuscadorBasico listaDeMatriculas={listadoDeMatriculas} />

                <TablaDeProcesos
                    listaDeMatriculas={listadoDeMatriculas.slice(limInf, limSup)}
                    rango={
                        listadoDeMatriculas.length > 0 ? (
                            <>
                                <span style={{ marginRight: '0.5em' }}>
                                    {limInf + 1}–{limSup} de {listadoDeMatriculas.length}
                                </span>
                                <Button
                                    icon='angle left'
                                    basic
                                    disabled={paginaActual === 1}
                                    onClick={this.retrocederPagina}
                                />
                                <Button
                                    icon='angle right'
                                    basic
                                    disabled={paginaActual >= numeroDePaginas}
                                    onClick={this.avanzarPagina}
                                />
                            </>
                        ) : (
                            'Cargando...'
                        )
                    }
                    filtroActual={filtroActual}
                    alCambiarFiltro={this.obtenerListaDeMatriculas}
                    alPresionarRecargar={() => this.obtenerListaDeMatriculas(filtroActual)}
                    cargando={cargando}
                />

                <Divider hidden />

                {numeroDePaginas > 0 && (
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            content='Anterior'
                            icon='angle left'
                            labelPosition='left'
                            disabled={paginaActual === 1}
                            onClick={() => {
                                window.scrollTo({ top: 130 });
                                this.retrocederPagina();
                            }}
                        />

                        <Button
                            content='Siguiente'
                            icon='angle right'
                            labelPosition='right'
                            disabled={paginaActual >= numeroDePaginas}
                            onClick={() => {
                                window.scrollTo({ top: 130 });
                                this.avanzarPagina();
                            }}
                        />
                    </div>
                )}
            </Container>
        );
    }

    private readonly retrocederPagina = () => {
        this.setState({ cargando: true });

        setTimeout(() => {
            this.setState(prev => ({
                paginaActual: prev.paginaActual > 1 ? prev.paginaActual - 1 : 1,
                cargando: false,
            }));
        }, 150);
    };

    private readonly avanzarPagina = () => {
        this.setState({ cargando: true });

        setTimeout(() => {
            this.setState(prev => ({
                paginaActual:
                    prev.paginaActual < prev.numeroDePaginas
                        ? prev.paginaActual + 1
                        : prev.numeroDePaginas,
                cargando: false,
            }));
        }, 150);
    };

    private readonly obtenerListaDeMatriculas = (tipo: Filtro) => {
        this.setState({ cargando: true });
        const comando = puedePoseerMatriculas(this.context.usuarioActual)
            ? 'resumenesDeProcesosDeAsesorActual'
            : 'resumenesDeProcesosDeMatricula';

        clienteApi
            .ejecutar(comando, { tipo })
            .then(resultados => {
                const listadoDeMatriculas = resultados;
                const numeroDePaginas = Math.ceil(listadoDeMatriculas.length / ITEMS_POR_PAGINA);

                this.setState(prev => ({
                    listadoDeMatriculas,
                    numeroDePaginas,
                    paginaActual:
                        prev.paginaActual > numeroDePaginas ? numeroDePaginas : prev.paginaActual,
                    cargando: false,
                    filtroActual: tipo,
                }));
            })
            .catch(error => {
                this.setState({ cargando: false });
                this.context.mostrarModalError(error);
            });
    };
}

export default ListaDeProcesos;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/index.tsx